import { IOption, IOptions } from '../../../common/common.types'

export interface ISpecialReport {
  id: string
  reportType: string
  ruleId: string
  completed: boolean
  dateOccurred: string
  dateReported: string
  author: IOption | null
  recordNumber: string
  crew: IOptionsWithSeq[]
  base: IOption | null
  unit: IOption | null
  supervisor: IOption | null
  personnelIssue: IOption | null
  isUrgent: boolean
  isFlagReport: boolean
  subject: string
  categories: ICategories
  subCategories: IOptions
  customQuestions: ICustomQuestion[]
  narrative: string
  comments: string
  autoEmail: string[]
  extraEmail: string[]
  reportReviewedBy: string
  status: IOption | null
}

export interface IOptionsWithSeq extends IOption {
  seq: number
}

export interface ISpecialReportsState extends ISpecialReport {
  __currentStep: number
  __currentSubStep: number
  __deleteSpecialReportId?: string
  specialReportsList: ISpecialReportList
}

export type ISpecialReportList = Array<ISpecialReport>

export interface ICustomQuestion {
  question: string
  answerId: string
  questionId: string
  fieldType: number
}

export interface ICategory {
  id: number
  name: string
  elementId: string
  label: string
  properties: { key: string; value: string }[]
  componentInterface: string
  emails: string | null
}

export const questionTypeLookup: Record<string, number> = {
  StringInput: 2,
  MultiSelect: 4,
  SingleSelect: 3,
  Toggle: 1,
  DateTime: 7,
  NumberPad: 6,
  CrewInput: 5,
}

export type ICategories = Array<ICategory>

export interface ISpecialReportsAction extends ISpecialReportsState {
  specialReportsState: ISpecialReportsState
  type: string
  ruleId: string
}
